import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MatTableModule} from "@angular/material/table";
import {MatCardModule} from "@angular/material/card";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonModule} from "@angular/material/button";
import {MatPaginatorModule} from "@angular/material/paginator";
import {CommonModule} from "@angular/common";


@Component({
    selector: 'app-data-table',
    standalone: true,
    imports: [CommonModule, MatCardModule, MatMenuModule, MatButtonModule, MatTableModule, MatPaginatorModule, RouterOutlet],
    templateUrl: './users.component.html',
    styleUrl: './users.component.scss'
})
export class UsersComponent {

}
